import { tns } from 'tiny-slider/src/tiny-slider';

var self = {};

self.initialise = function () {
  const carouselTestimonial = document.querySelectorAll('.js-carousel-testimonial');
  const carouselTestimonialNav = document.querySelectorAll('.js-carousel-testimonial-nav');

  if (!carouselTestimonial) {
    return;
  }

  for (let i = 0; i < carouselTestimonial.length; i++) {
    tns({
      container: carouselTestimonial[i],
      controls: false,
      nav: true,
      navContainer: carouselTestimonialNav[i],
      autoplay: true,
      autoplayButtonOutput: false,
      items: 1,
      center: true,
      mouseDrag: true,
    });
  }

  const carouselCta = document.querySelectorAll('.js-carousel-cta');

  if (!carouselCta) {
    return;
  }

  for (let i = 0; i < carouselCta.length; i++) {
    tns({
      container: carouselCta[i],
      controls: false,
      nav: true,
      autoplay: false,
      center: true,
      mouseDrag: true,
      itemWidth: 400,
      loop: false,
      responsive: {
        '350': {
          items: 1,
        },
        '1024': {
          items: 2,
          disable: true,
        },
      },
    });
  }
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-carousel.js